import { uuidModule } from "@/modules/uuid";
import { BaseSyncOperation } from "@/store/sync/operations/BaseSyncOperation";
import { OptimisticSyncUpdate, SyncModelData, SyncOperationKind } from "@/store/sync/types";
import { NoteSourceDeletedSyncUpdateValue, NoteSourceModelData } from "@/store/sources/types";
import { resolveNoteSourceSyncModelUuid } from "@/modules/uuid/sync-models/resolveNoteSourceSyncModelUuid";
import { IDeleteNoteSourceOperation } from "@/store/sync/operations/types";

export class DeleteNoteSourceOperation extends BaseSyncOperation<IDeleteNoteSourceOperation> {
  get operationKind(): SyncOperationKind {
    return "DELETE_NOTE_SOURCE";
  }

  async generateOptimisticUpdates(): Promise<OptimisticSyncUpdate<SyncModelData>[]> {
    const noteSourceId = resolveNoteSourceSyncModelUuid({
      noteId: this.payload.note_id,
      sourceId: this.payload.source_id,
    });
    const existingNoteSource = await this.store.noteSources.getAsync(noteSourceId);
    if (!existingNoteSource) return [];

    const noteValue: NoteSourceDeletedSyncUpdateValue = {
      model_id: noteSourceId,
      model_kind: "NOTE_SOURCE",
      model_version: existingNoteSource.modelVersion,
    };
    const noteSourceDeleted: OptimisticSyncUpdate<NoteSourceModelData> = {
      optimistic_update_id: uuidModule.generate(),
      locally_committed_at: this.committedAt,
      kind: "DELETED",
      value: noteValue,
    };
    return [noteSourceDeleted];
  }

  async triggerRecompute(): Promise<void> {
    const noteSourceId = resolveNoteSourceSyncModelUuid({
      noteId: this.payload.note_id,
      sourceId: this.payload.source_id,
    });
    await this.store.noteSources.recompute(noteSourceId);
  }
}
